export default "__VITE_ASSET__BZQladu0__"